import { Component, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MarkantElementsModule } from '@markant/elements-angular';
import {
  FormControlErrorPipe,
  FormControlIsRequiredPipe,
  FormControlKeyErrorPipe,
} from '@markant-platform/shared/util-pipes';
import { TranslocoPipe } from '@jsverse/transloco';
import { UiCountrySelectComponent } from '@markant-platform/shared/ui-components';
import { NgIf } from '@angular/common';
import { OrganizationFormGroup } from '@markant-platform/registration/model';

@Component({
  selector: 'markant-platform-registration-organization',
  templateUrl: './registration-organization.component.html',
  standalone: true,
  styleUrls: ['../registration.scss'],
  imports: [
    MarkantElementsModule,
    ReactiveFormsModule,
    FormControlErrorPipe,
    FormControlKeyErrorPipe,
    TranslocoPipe,
    UiCountrySelectComponent,
    NgIf,
    FormControlIsRequiredPipe,
  ],
})
export class RegistrationOrganizationComponent {
  @Input() organizationForm!: OrganizationFormGroup;
  @Input() showError?: boolean;

  pathToTranslation = 'organization.details.fields.';

  onCountryChanged(): void {
    this.organizationForm.markAsDirty();
  }
}
